import { render, staticRenderFns } from "./AccountReceivable.vue?vue&type=template&id=36aab114&scoped=true"
import script from "./AccountReceivable.vue?vue&type=script&lang=js"
export * from "./AccountReceivable.vue?vue&type=script&lang=js"
import style0 from "./AccountReceivable.vue?vue&type=style&index=0&id=36aab114&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36aab114",
  null
  
)

export default component.exports